import { Info } from "lucide-react";
import { SectionCard } from "../Domain/domainIntelligenceParts";
import { PROVENANCE_BAR_CLS, type BySourceEntry } from "./utilities";

export function ProvenanceSection({ entries }: { entries: BySourceEntry[] }) {
  return (
    <SectionCard headerLabel="Provenance breakdown" rightLabel="By source">
      <div className="p-4">
        {entries.length === 0 ? (
          <div className="flex items-center justify-center gap-2 py-4 text-sm text-muted-foreground">
            <Info className="size-4" />
            No provenance data reported.
          </div>
        ) : (
          <ul className="flex flex-col gap-2.5">
            {entries.map((entry) => (
              <li
                key={entry.key}
                className="flex items-center gap-3 min-w-0"
              >
                <span className="w-40 shrink-0 text-[12px] text-foreground break-words">
                  {entry.label}
                </span>
                <div className="relative h-1.5 flex-1 min-w-[60px] rounded-full bg-muted overflow-hidden">
                  <div
                    className={PROVENANCE_BAR_CLS}
                    style={{ width: `${Math.round(entry.pct)}%` }}
                  />
                </div>
                <span className="text-[11.5px] font-semibold text-foreground tabular-nums whitespace-nowrap">
                  {entry.count}
                </span>
                <span className="w-14 text-right text-[11px] text-muted-foreground tabular-nums whitespace-nowrap">
                  {entry.pct.toFixed(1)}%
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </SectionCard>
  );
}
